import moment from "moment"
import React, { useEffect, useState } from "react"
import { Badge, Tab, Tabs } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import ScaleLoader from "react-spinners/ScaleLoader"
import api from "../../api"
import { useAppDispatch, useAppSelector } from "../../app/hooks"
import { RootState } from "../../store"
import { loadReadyParcelsPick, loadSuitesPick, resetSuccess } from "../../store/pick.store"
import Header from "../Layout/Header"
import PickBasic from "./PickBasic"
import PicksSuite from "./PicksSuite"
import ScanedSuiteModal from "./ScanedSuiteModal"

const Pick = () => {
    const { userInfo } = useAppSelector((state: RootState) => state.auth)
    const { suitesPick, parcelsBasic, loading, success, shipmentTracking, scannedSuite } = useAppSelector(
        (state: RootState) => state.picks
    )
    const dispatch = useAppDispatch()

    //Date Picker Logic
    const [startDate, setStartDate] = useState()
    const [endDate, setEndDate] = useState()
    const [buttonId, setButtonId] = useState("")
    const [show, setShow] = useState(false)
    const [exportLinkLoading, setExportLinkLoading] = useState(false)
    const [error, setError] = useState("")
    const { selectedWarehouse } = useAppSelector((state: RootState) => state.warehouses)

    const defaultWarehouse = userInfo?.ParcelHubUserWarehouse?.find(
        (uw: Record<string, any>) => uw?.is_default
    )?.warehouse_id

    useEffect(() => {
        dispatch(loadSuitesPick({ warehouse: selectedWarehouse?.toString() }))
        dispatch(loadReadyParcelsPick({ warehouse: selectedWarehouse?.toString() }))
    }, [selectedWarehouse])

    const handleExportReadyToPick = async () => {
        try {
            setExportLinkLoading(true)
            const res = await api.pick.pickPDF()
            if (res?.data?.status) {
                const link = res?.data?.payload as string
                const linkElement = document.getElementById("exportReadyToPickParcels") as HTMLAnchorElement
                linkElement.href = link
                linkElement.click()
            }
        } catch (error) {
            setError("Something went wrong, try again later.")
        }
        setExportLinkLoading(false)
    }

    const { t } = useTranslation()
    useEffect(() => {
        const dateObj2 = {
            start_date: startDate ? moment(startDate).format("YYYY-MM-DD") : "2020-04-15",
            end_date: endDate
                ? moment(endDate).format("YYYY-MM-DD")
                : moment().add(1, "days").format("YYYY-MM-DD")
        }
    }, [endDate])

    useEffect(() => {
        if (success) {
            dispatch(loadSuitesPick({ warehouse: selectedWarehouse?.toString() }))
            dispatch(loadReadyParcelsPick({ warehouse: selectedWarehouse?.toString() }))
            setShow(false)
            document.getElementById("printLabel")?.click()
        }
        dispatch(resetSuccess())
    }, [success, selectedWarehouse])

    return (
        <>
            {loading || !userInfo?.accessToken ? (
                <div className="loader row justify-content-center">
                    <ScaleLoader color="#15397F" width={4} height={40} />
                </div>
            ) : (
                <div className="pick-container">
                    <Header
                        title={t("Pick")}
                        records={suitesPick.length + parcelsBasic.length}
                        data={suitesPick}
                        name="Pick"
                        buttonId={buttonId}>
                        <div className="mx-2">
                            {/*<DateRangePickerCustom setStartDate={setStartDate} setEndDate={setEndDate} />*/}
                        </div>
                    </Header>

                    <div className="row  d-flex tabs-data px-2">
                        <Tabs defaultActiveKey="suites" id="suites-tab" className="mt-4">
                            <Tab
                                eventKey="suites"
                                title={
                                    <>
                                        {t("Suites")}
                                        <Badge className="mx-2 px-2">{suitesPick.length}</Badge>
                                    </>
                                }>
                                <PicksSuite setShow={setShow} picks={suitesPick} setButtonId={setButtonId} />
                            </Tab>
                            <Tab
                                eventKey="basic"
                                title={
                                    <>
                                        {t("Ready")}
                                        <Badge className="mx-2 px-2">{parcelsBasic.length}</Badge>
                                    </>
                                }>
                                <PickBasic
                                    picksBasic={parcelsBasic}
                                    setButtonId={setButtonId}
                                    exportLinkLoading={exportLinkLoading}
                                    handleExportReadyToPick={handleExportReadyToPick}
                                />
                            </Tab>
                        </Tabs>
                    </div>
                    <ScanedSuiteModal scannedSuite={scannedSuite} show={show} setShow={setShow} />

                    <a
                        id="printLabel"
                        href={shipmentTracking?.tracking_label}
                        target="_blank"
                        rel="noreferrer"
                    />

                    <a id="exportReadyToPickParcels" target="_blank" rel="noreferrer" />
                </div>
            )}
        </>
    )
}

export default Pick
